import {
  FETCH_SALES_COMPETENCY_REVIEWS,
  FETCH_SALES_COMPETENCY_REVIEWS_SUCCESS,
  FETCH_SALES_COMPETENCY_REVIEWS_ERROR,
  SAVE_SALES_COMPETENCY_REVIEW,
  SAVE_SALES_COMPETENCY_REVIEW_SUCCESS,
  SAVE_SALES_COMPETENCY_REVIEW_ERROR,
} from '../actions/types';

//todo paginate this
const DEFAULT_STATE = {
  data: [],
  loading: true,
  saving: false,
  error: null
}

export default function(state = DEFAULT_STATE, action){
  // console.log('action received: ', action);
  switch(action.type){
    case FETCH_SALES_COMPETENCY_REVIEWS:
      return {
        ...state,
        data: null,
        loading: true,
        error: null,
      }
    break;
    case FETCH_SALES_COMPETENCY_REVIEWS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      }
    break;
    case FETCH_SALES_COMPETENCY_REVIEWS_ERROR:
      return {
        ...state,
        data: null,
        loading: false,
        error: action.payload
      }
    break;
    case SAVE_SALES_COMPETENCY_REVIEW:
      return {
        ...state,
        saving: true,
        error: null,
      }
    break;
    case SAVE_SALES_COMPETENCY_REVIEW_SUCCESS:
      return {
        ...state,
        data: [
          ...state.data,
          action.payload
        ],
        saving: false,
        error: null,
      }
    break;
    case SAVE_SALES_COMPETENCY_REVIEW_ERROR:
      return {
        ...state,
        saving: false,
        error: action.payload,
      }
    break;
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/salesCompetencyReviewsReducer.js